import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EquipmentModel, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class EquipmentModelService extends BaseApiService<EquipmentModel> {
  get cacheKey(): StorageKey {
    return StorageKey.equipmentModelServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/equipmentModels`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  list(params: {[params: string]: string}): Promise<Pagination<EquipmentModel>> {
    return super.list(this.removeContractId(params));
  }

  protected parse(obj) {
    return EquipmentModel.parse(obj);
  }

  protected unparse(obj) {
    return EquipmentModel.unparse(obj);
  }
}
